import { useEffect, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { useAppDispatch, useAppSelector } from 'redux/hooks';
import { RootState } from 'redux/store';
import { getStoreGroupsTable } from 'redux/slices/StoreGroups';
import { Title, Table } from 'components';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { getOwners } from 'redux/slices/Owners';
import { FormatDateToDMYH, getOwnerNameById } from 'helpers/data/dataHandling';

export function StoreGroups() {
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const storeGroups = useAppSelector((state: RootState) => state.storeGroups);
	const owners = useAppSelector((state: RootState) => state.owners);

	useEffect(() => {
		dispatch(getStoreGroupsTable());
		dispatch(getOwners());
	}, []);

	const columns = [
		{
			Header: 'ID',
			accessor: 'id',
			defaultCanSort: true,
			width: 100,
		},
		{
			Header: 'Name',
			accessor: 'name',
			defaultCanSort: true,
			width: 400,
			Cell: (row: any) => <Link to={`/support/storegroup/${row.cell.row.original.id}`}>{row.value}</Link>,
		},
		{
			Header: 'Owner Name',
			accessor: 'ownerId',
			width: 1200,
			defaultCanSort: true,
			Cell: (row: any) => <Link to={`/support/storegroup/${row.cell.row.original.id}`}>{getOwnerNameById(row.value, owners.table)}</Link>,
		},
		{
			Header: "Comments",
			accessor: "comments",
			defaultCanSort: true,
			width: 1200,
			Cell: (row: any) => <Link to={`/support/storegroup/${row.cell.row.original.id}`}>{row.value}</Link>,
		},
		{
			Header: "Last User Login",
			accessor: "userLastLoginDate",
			defaultCanSort: true,
			enableColumnFilter: false,
			width: 200,
			Cell: (row: any) => <Link to={`/support/storegroup/${row.cell.row.original.id}`}>{row.value}</Link>,
		},
		{
			Header: "Created",
			accessor: "created",
			defaultCanSort: true,
			enableColumnFilter: false,
			width: 200,
			Cell: (row: any) => <Link to={`/support/storegroup/${row.cell.row.original.id}`}>{FormatDateToDMYH(row.value)}</Link>,
		},
	];

	return (
		<>
			<Title pageTitle="Store Groups" parent="Support" />
			<Row>
				<Col xs={12}>
					<Card>
						<Card.Body>
							<Row className="mb-1">
								<div className="page-container">
									<Table
										columns={columns}
										data={storeGroups.table}
										pageSize={15}
										isSortable={true}
										pagination={true}
										isSelectable={true}
										isSearchable={true}
										searchColumns={['Name', 'Site ID']}
										addNewRow={() => navigate(`/support/storegroup/new/`)}
										reloadTableRows={() => dispatch(getStoreGroupsTable())}
									/>
								</div>
							</Row>
						</Card.Body>
					</Card>
				</Col>
			</Row>
		</>
	);
}